<template>
  <div>
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('views.version_list.versions') }}
      </h1>
    </div>
    <v-data-table
      fixed-header
      :headers="headers"
      :items="items"
      :footer-props="{
        itemsPerPageOptions: [50],
      }"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      :loading-text="$t('common.loading_data')"
    >
      <template v-slot:item.updatedAt="{ item }">
        {{ $moment.utc(item.updatedAt).format('L LT') }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'Versions',

  data() {
    return {
      items: [],
      options: {
        page: 1,
        sortBy: ['service'],
      },
      total: 0,
      loading: false,

      headers: [
        { text: this.$t('views.version_list.service'), value: 'service' },
        { text: this.$t('views.version_list.version'), value: 'version' },
        { text: this.$t('common.date_utc'), value: 'updatedAt' },
      ],
    };
  },

  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },

  methods: {
    async getItems(filtered) {
      this.loading = true;

      if (filtered) {
        this.options.page = 1;
      }
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;

      const params = {};
      if (itemsPerPage !== -1) {
        params.pageSize = itemsPerPage;
        params.page = page;
      }
      if (sortBy.length) {
        params.sort = `${sortDesc[0] ? '-' : ''}${sortBy[0]}`;
      }

      try {
        const { data = {} } = await this.$http.get('/versions', { params });
        this.items = (data.rows || []).map((item) => ({
          ...item,
          createdAt: new Date(item.createdAt),
          updatedAt: new Date(item.updatedAt),
        }));
        this.total = data.total;
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
